<main>
  <div #statusBarWrapper>
    <bi-notification-bar
      *ngIf="noMessages$ | async"
      class="mb-0"
      widthSize="large"
      [title]="'iframe.operationalMap.NoMessages' | translate"
      [dismissable]="false"
      [cssFontColor]="urlParams.noMessagesFontColor"
      backgroundColor="green"
      [cssBackgroundColor]="urlParams.noMessagesBackgroundColor"
      [font]="urlParams.noMessagesFont"
    />
  </div>

  <bi-map
    class="iframe-component"
    #map
    *ngIf="mapModuleModel && urlParams?.height && (noMessages$ | async) != undefined"
    [enableSearch]="mapModuleModel.customerSettings.hasSearchInput"
    [countryId]="mapModuleModel.countryId"
    [noPosListSearch]="true"
    [enableDraw]="false"
    [mapHeight]="urlParams.height"
    [enableMarkerClusters]="false"
    [markersDeletable]="false"
    [isForDriftStatus]="true"
    [reloadButtonClick]="setupMapLatLngAndZoom"
    [defaultMapLayerId]="mapModuleModel.customerSettings.mapLayerId"
    (mapReady)="onMapReady($event)"
  />
  <bi-spinner spinnerSize="large" [hasBackground]="loading" [centerInParent]="true" *ngIf="loading || (!mapModuleModel && !urlParams?.height && (noMessages$ | async) == undefined)" />
</main>
